import { jsx } from "react/jsx-runtime";
import { useMemo, useCallback } from "react";
import { useSearchParams } from "react-router";
import { EventService, isDefined } from "@perxis-auto/shared/lib";
import { Icon } from "@perxis-auto/ui-kit/lib/components/Icon";
import "../../../shared/config/env.js";
import { APP_EVENTS } from "../../../shared/config/events.js";
import "../../../shared/context/constructor.js";
import { useThisContext, useLoadingContext } from "../../../shared/context/this.js";
import { useMergedConstructorItemProps } from "../../../shared/lib/constructor/hooks/useMergedConstructorItemProps.js";
import "../../../shared/lib/constructor/mergeConstructor.js";
import "@perxis-auto/shared";
import "@perxis-auto/ui-kit";
import { QueryParamsEnum } from "../../../shared/types/router.js";
import "../../../shared/lib/logger/index.js";
import { useAppNavigate } from "../../../shared/lib/router/hooks/useAppNavigate.js";
import "@perxis-auto/shared/lib/lib/is/isObject";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import "redux";
import "../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import { GET_DEFAULT_CONTAINER_PROPS } from "../config/props.js";
const useContainer = (item) => {
  const {
    id,
    type = "primary",
    iconName,
    iconSize,
    onClick,
    redirects,
    scrollTo,
    ...props
  } = useMergedConstructorItemProps(item, GET_DEFAULT_CONTAINER_PROPS);
  const navigate = useAppNavigate();
  const [_, setSearchParams] = useSearchParams();
  const eventService = EventService.getInstance();
  const data = useThisContext();
  const isLoading = useLoadingContext();
  const eventPayload = useMemo(
    () => ({
      id,
      ...isDefined(data) && { data }
    }),
    [id, data]
  );
  const handleClick = useCallback(
    (e) => {
      var _a, _b;
      if (isDefined(id)) {
        eventService.sendEvent(APP_EVENTS.ButtonClicked, eventPayload);
      }
      if (scrollTo) {
        setSearchParams((prev) => {
          prev.set(QueryParamsEnum.ScrollTo, scrollTo);
          return prev;
        });
      }
      const hasRedirect = isDefined((_a = redirects == null ? void 0 : redirects.onClick) == null ? void 0 : _a.to);
      if (hasRedirect) {
        const { id: vehicleId } = data || {};
        navigate(redirects.onClick.to, {
          ...redirects.onClick.options,
          params: {
            ...(_b = redirects.onClick.options) == null ? void 0 : _b.params,
            ...isDefined(vehicleId) && { vehicleId }
          }
        });
      }
      if (onClick) {
        onClick(e, data);
      }
    },
    [
      data,
      eventPayload,
      eventService,
      navigate,
      onClick,
      redirects == null ? void 0 : redirects.onClick.options,
      redirects == null ? void 0 : redirects.onClick.to,
      scrollTo,
      setSearchParams
    ]
  );
  const resolvedIcon = useMemo(() => {
    if (typeof iconName !== "string") {
      return null;
    }
    return /* @__PURE__ */ jsx(Icon, { name: iconName, size: iconSize, sticker: "button-icon" });
  }, [iconName, iconSize]);
  return {
    ...props,
    type,
    icon: resolvedIcon,
    onClick: handleClick,
    isLoading
  };
};
export {
  useContainer
};
